import React from 'react';

import { GhostButton, PrimaryButton, WarningButton } from '@minecraft.atoms';

import { MediaUploader } from './MediaUploader';

type Props = Omit<React.ComponentProps<typeof MediaUploader>, 'renderChildren'> &
  (
    | ({ type?: 'primary'; onClick?: () => void } & React.ComponentProps<typeof PrimaryButton>) // type is optional because primary is the default
    | ({ type: 'ghost'; onClick?: () => void } & React.ComponentProps<typeof GhostButton>)
    | ({ type: 'warning'; onClick?: () => void } & React.ComponentProps<typeof WarningButton>)
  );

export const MediaUploaderButton: React.FC<Props> = ({
  children,
  type,
  onUploadCallback,
  onCloseUploader,
  ...props
}) => {
  return (
    <MediaUploader
      {...props}
      onUploadCallback={onUploadCallback}
      onCloseUploader={onCloseUploader}
      renderChildren={({ toggleModal }) => {
        switch (type) {
          case 'ghost':
            return (
              <GhostButton
                {...props}
                onClick={() => {
                  toggleModal();
                  props.onClick && props.onClick();
                }}
              >
                {children}
              </GhostButton>
            );
          case 'warning':
            return (
              <WarningButton
                {...props}
                onClick={() => {
                  toggleModal();
                  props.onClick && props.onClick();
                }}
              >
                {children}
              </WarningButton>
            );
          case 'primary':
          default:
            return (
              <PrimaryButton
                {...props}
                onClick={() => {
                  toggleModal();
                  props.onClick && props.onClick();
                }}
              >
                {children}
              </PrimaryButton>
            );
        }
      }}
    />
  );
};
